export const PLATFORM_COOKIES = {
  WRAPPER: 'wrapper',
  IP_ADDRESS: 'geocomply_ip_address',
  IS_QL: 'x-is-quick-launch',
  ANDROID_APP_VERSION: 'X-Android',
  USER_ID: 'User-ID',
};
